import { useEffect, useRef } from 'react';
import { StringUtils } from '@manifoldxyz/js-ts-utils';

interface ScribeIframeProps {
  src: string;
}

export default function ScribeIframe({ src }: ScribeIframeProps) {
  const frameRef = useRef<HTMLIFrameElement | null>(null);

  /**
   * Function to resize the iframe to the height of the content
   * The height is sent from the iframe (via postMessage) when the content is ready
   * https://github.com/manifoldxyz/studio-app-rich-text-minting/blob/main/src/common/util.ts#L193
   */
  const handleMessage = (event: MessageEvent) => {
    if (frameRef.current) {
      const { type, height } = event.data;
      if (type === 'resize' && typeof height === 'number') {
        frameRef.current.style.height = `${height}px`;
        frameRef.current.style.minHeight = `${height}px`;
      }
    }
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage, false);

    return () => {
      window.removeEventListener('message', handleMessage, false);
    };
  }, [src]);

  return (
    <div
      className={StringUtils.classnames(
        'manifold',
        'm-lazy-media',
        'lazy-iframe',
        'm-claim--w-full',
      )}
    >
      <iframe
        ref={frameRef}
        src={src}
        title="listing-iframe"
        sandbox="allow-same-origin allow-scripts allow-popups"
        allow="camera; microphone; accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        className={StringUtils.classnames(
          'm-claim--w-full',
          'm-claim--block',
          'm-claim--border-none',
          'm-claim--min-h-[860px]',
          'm-claim--rounded-[30px]',
          'm-claim--border-2',
          'm-claim--border-[var(--border-color)]',
          'md:m-claim--min-h-[480px]',
        )}
      />
    </div>
  );
}
